import { useState, useMemo } from 'react';
import { SLIDER_CONFIG, PERCENT_DIVISOR, MODE_SELF_DELIVERY, RISK_OPTIONS, DEFAULT_RISK_INDEX } from '@/constants/calculator';

export function useCalculator() {
  const [mode, setMode] = useState(MODE_SELF_DELIVERY);
  const [managedCost, setManagedCost] = useState(SLIDER_CONFIG.MANAGED_COST.default);
  const [selfDeliveryRate, setSelfDeliveryRate] = useState(SLIDER_CONFIG.SELF_DELIVERY_RATE.default);
  const [holidayPay, setHolidayPay] = useState(SLIDER_CONFIG.HOLIDAY_PAY.default);
  const [supervisorCost, setSupervisorCost] = useState(SLIDER_CONFIG.SUPERVISOR_COST.default);
  const [nonProductiveTime, setNonProductiveTime] = useState(SLIDER_CONFIG.NON_PRODUCTIVE.default);
  const [nonEssentialDowntime, setNonEssentialDowntime] = useState(SLIDER_CONFIG.NON_ESSENTIAL.default);
  const [riskIndex, setRiskIndex] = useState(DEFAULT_RISK_INDEX);

  const calculated = useMemo(() => {
    const holidayAmount = selfDeliveryRate * (holidayPay / PERCENT_DIVISOR);
    const nonProductiveAmount = selfDeliveryRate * (nonProductiveTime / PERCENT_DIVISOR);
    const nonEssentialAmount = selfDeliveryRate * (nonEssentialDowntime / PERCENT_DIVISOR);
    const totalCosts = holidayAmount + nonProductiveAmount + nonEssentialAmount + supervisorCost;
    const selfDeliveryCostInclusive = selfDeliveryRate + totalCosts;

    const riskOption = RISK_OPTIONS[riskIndex];
    const riskAllowance = selfDeliveryCostInclusive * (riskOption.allowancePct / PERCENT_DIVISOR);
    const adjustedSelfDelivery = selfDeliveryCostInclusive + riskAllowance;

    return {
      selfDeliveryCostInclusive: parseFloat(selfDeliveryCostInclusive.toFixed(2)),
      totalCosts: parseFloat(totalCosts.toFixed(2)),
      holidayAmount: parseFloat(holidayAmount.toFixed(2)),
      nonProductiveAmount: parseFloat(nonProductiveAmount.toFixed(2)),
      nonEssentialAmount: parseFloat(nonEssentialAmount.toFixed(2)),
      riskOption,
      riskAllowance: parseFloat(riskAllowance.toFixed(2)),
      adjustedSelfDelivery: parseFloat(adjustedSelfDelivery.toFixed(2)),
    };
  }, [selfDeliveryRate, holidayPay, supervisorCost, nonProductiveTime, nonEssentialDowntime, riskIndex]);

  return {
    mode,
    setMode,
    riskIndex,
    setRiskIndex,
    values: { managedCost, selfDeliveryRate, holidayPay, supervisorCost, nonProductiveTime, nonEssentialDowntime },
    setters: { setManagedCost, setSelfDeliveryRate, setHolidayPay, setSupervisorCost, setNonProductiveTime, setNonEssentialDowntime },
    calculated,
  };
}
